module.exports = __webpack_public_path__ + "static/media/solar-cells.76f3962e.svg";